<template>
  <div>
    <vue-modal id="profileModal"
               classes="vue-modal-container"
               height="auto"
               name="profile-modal"
               scrollable
               width="80%">
      <div class="header">
        <h3>Profil</h3>
        <button class="close-modal"
                @click="$modal.hide('profile-modal')">
          <i class="close icon"/>
        </button>
      </div>
      <div class="content">
        <div class="row">
          <div class="small-12 columns">
            <div class="ui form">
              <div class="field">
                <label>Teljes név
                  <input v-model="userName"
                         type="text">
                </label>
              </div>
            </div>
          </div>
          <!--
          <div class="small-12 columns">
            <div class="ui form">
              <div class="field">
                <label>Email-cím
                  <input v-model="userEmail" type="email">
                </label>
              </div>
            </div>
          </div>
          -->
          <div class="small-12 columns">
            <div class="ui form">
              <div class="field">
                <label>Telefonszám
                  <input v-model="userPhone"
                         type="text">
                </label>
              </div>
            </div>
          </div>
          <div class="small-12 columns">
            <div class="ui form">
              <div class="field">
                <label>Jelszó
                  <input v-model="userPwdOne"
                         placeholder="********"
                         type="password">
                </label>
              </div>
            </div>
          </div>
          <div class="small-12 columns">
            <div class="ui form">
              <div class="field">
                <label>Jelszó ismét
                  <input v-model="userPwdTwo"
                         placeholder="********"
                         type="password">
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="ui positive button"
                @click="saveModifications">Mentés
        </button>
        <button class="ui button"
                @click="changeEmailAddress">Email cím módosítása
        </button>
      </div>
    </vue-modal>
    <change-email-modal/>
  </div>
</template>

<script>
/* eslint-disable */
import notify from '../../notify'
import sha1 from 'js-sha1'
import ChangeEmailModal from './ChangeEmailModal'

export default {
  props: ['name', 'email', 'phone', 'isGoogleCalendar', 'passes'],
  data () {
    return {
      userName: this.name,
      // userEmail: this.email,
      userPhone: this.phone,
      isUserGoogleCalendar: this.isGoogleCalendar,
      userPwdOne: '',
      userPwdTwo: '',
    }
  },
  methods: {
    saveModifications () {
      let userData = {
        userName: this.userName,
        // email: this.userEmail,
        phone: this.userPhone,
        isGoogleCalendar: this.isUserGoogleCalendar,
        pwd: this.userPwdOne,
      }
      let isUserDataValid = true
      let warningMsg = 'Minden mező kitöltése kötelező'

      /*
      if (!isEmailValid(userData.email)) {
        isUserDataValid = false
      }
      */

      if (userData.userName && userData.userName.length < 1) {
        isUserDataValid = false
      }

      if (userData.phone && userData.phone.length < 1) {
        isUserDataValid = false
      }

      if (userData.pwd.length < 1) {
        userData.pwd = null
      } else if (userData.pwd.length >= 6) {
        if (this.userPwdOne !== this.userPwdTwo) {
          isUserDataValid = false
          warningMsg = 'A jelszavak nem egyeznek'
        } else {
          userData.pwd = sha1(userData.pwd)
        }
      } else {
        isUserDataValid = false
        warningMsg = 'A jelszónak minimum 6 karakterből kell állnia'
      }

      if (isUserDataValid) {
        this.$emit('saveUserModifications', userData)
      } else {
        notify.warning(warningMsg)
      }

      function isEmailValid (email) {
        // eslint-disable-next-line
        let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regExp.test(email)
      }

    },
    changeEmailAddress () {
      /* eslint-disable */
      this.$modal.show('change-email-modal')
      this.$modal.hide('profile-modal')
    },
  },
  components: {
    ChangeEmailModal,
  },
}
</script>
